import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FeedLogs from './FeedLogs';
import FeedSettings from './FeedSettings';
import RefreshIcon from '../../assets/icons/refreshIcon';
import { readableStampWithZone } from '../../utils/dateFunctions';
import './feedCenter.scss';

import {
	getFeedLogs, getVehicleDataFeeds, getFeedCenter,
} from '../../actions/apiGetInfo';

class FeedCenter extends Component {
	constructor(props) {
		super(props);

		this.state = { username: '', password: '' };
	}

	componentDidMount() {
		this.refreshFeedHistory();
		this.props.getFeedCenter();
	}

	componentDidUpdate(prevProps) {
		const prevId = prevProps.installation && prevProps.installation.id;
		const nextId = this.props.installation && this.props.installation.id;
		if (nextId != null && nextId !== prevId) {
			this.refreshFeedHistory();
		}
	}

	refreshFeedHistory() {
		this.props.getFeedLogs();
		this.props.getVehicleDataFeeds();
	}

	historyLoadedLabel() {
		const loadedAt = this.props.vehicle_data_feeds_loaded_at;
		return loadedAt ? `Loaded ${readableStampWithZone(loadedAt)}` : 'Loaded';
	}

	render() {
		return (
			<div className="sidebar-offcanvas feed-center-page col-md-12">
				<div className="card space-top-0">
					<h3 className="text-center pad-top-1">Feed Center</h3>
					<FeedSettings />
				</div>
				<div className="card space-top-2">
					<h3 className="text-center pad-top-1">Feed History</h3>
					<div className="feed-history-toolbar">
						<span className="feed-history-loaded">{this.historyLoadedLabel()}</span>
						<button
							type="button"
							className="feed-history-refresh"
							onClick={() => this.refreshFeedHistory()}
							aria-label="Refresh"
							title="Refresh"
						>
							<RefreshIcon color="#5b6474" />
						</button>
					</div>

					<div className="card bg-light space-bottom-1 space-top-1 mx-auto w-100 p-3">
						<FeedLogs {...this.props} />
					</div>
				</div>
			</div>
		);
	}
}

const mappedActions = {
	getFeedLogs,
	getVehicleDataFeeds,
	getFeedCenter,
};

function mapStateToProps(state) {
	return {
		installation: state.settings_dealerships.installation,
		feed_logs: state.settings_feed.feed_logs,
		vehicle_data_feeds: state.settings_feed.vehicle_data_feeds,
		vehicle_data_feeds_loaded_at: state.settings_feed.vehicle_data_feeds_loaded_at,
		feed_errors: state.settings_feed.feed_errors,
		feed_notification_settings: state.settings_feed.feed_notification_settings,
		feed_providers: state.settings_feed.feed_providers,
		feed_provider_settings: state.settings_feed.feed_provider_settings,
		feed_provider_rules: state.settings_feed.feed_provider_rules,
	};
}
export default connect(mapStateToProps, mappedActions)(FeedCenter);
